(() => {
  const tiers = [
    { quantity: 4, percentage: 20, code: 'CHAUXE4' },
    { quantity: 3, percentage: 15, code: 'CHAUXE3' },
    { quantity: 2, percentage: 10, code: 'CHAUXE2' }
  ];
  const nativeFetch = window.fetch.bind(window);
  const NativeXHR = window.XMLHttpRequest;
  let syncing = false;
  let syncQueued = false;
  let syncTimer;
  let lastObservedQuantity = null;
  let mutationCheckPending = false;
  let requestedLeadOpened = false;

  const tierFor = (quantity) => tiers.find((tier) => quantity >= tier.quantity) || null;
  const cartMutation = (url = '') => /\/cart\/(add|change|update)(?:\.js)?(?:\?|$)/.test(String(url));
  const cartAddition = (url = '') => /\/cart\/add(?:\.js)?(?:\?|$)/.test(String(url));

  function openCartDrawer() {
    const drawer = document.querySelector('cart-drawer');
    if (!drawer) return;
    if (typeof drawer.open === 'function') {
      drawer.open();
      return;
    }
    drawer.classList.add('animate', 'active');
    drawer.setAttribute('open', '');
    document.body.classList.add('overflow-hidden');
  }

  function openCartAfterAdd() {
    [500, 1000, 1800].forEach((delay) => window.setTimeout(openCartDrawer, delay));
  }

  function ensureLeadFormCartButton() {
    document.querySelectorAll('.chauxe-leadform-cart-wrap').forEach((element) => element.remove());
    document.querySelectorAll('cart-drawer button').forEach((button) => {
      const currentText = (button.textContent || '').trim();
      const isLeadFormButton = button.matches('.leadform-action-button, [data-button-id="order-now"]') || currentText.includes('\u0623\u0637\u0644\u0628 \u0627\u0644\u0622\u0646');
      if (!isLeadFormButton) return;
      const label = button.querySelector('.btn-text');
      if (label) label.textContent = 'Valider la commande';
      else button.textContent = 'Valider la commande';
      button.setAttribute('aria-label', 'Valider la commande');
      button.style.setProperty('width', '100%', 'important');
      button.style.setProperty('min-height', '5.2rem', 'important');
      button.style.setProperty('font-weight', '700', 'important');
    });
  }

  function selectedProductCount() {
    const upsells = Array.from(document.querySelectorAll('product-info-upsell'));
    return 1 + upsells.filter((item) => item.dataset.selected === 'true').length;
  }

  let upsellDisplayTimer;
  function refreshUpsellOfferDisplay(delay = 0) {
    window.clearTimeout(upsellDisplayTimer);
    upsellDisplayTimer = window.setTimeout(() => {
      updateOfferDisplay(selectedProductCount(), false);
    }, delay);
  }

  function updateOfferDisplay(quantity = selectedProductCount(), applied = false) {
    const box = document.querySelector('.chauxe-volume-discounts');
    if (!box) return;
    const activeTier = tierFor(quantity);
    box.querySelectorAll('[data-chauxe-tier]').forEach((item) => {
      const active = activeTier && Number(item.dataset.chauxeTier) === activeTier.quantity;
      item.style.outline = active ? '3px solid #b86632' : '';
      item.style.transform = active ? 'translateY(-2px)' : '';
    });
    let status = box.querySelector('[data-chauxe-status]');
    if (!status) {
      status = document.createElement('p');
      status.dataset.chauxeStatus = 'true';
      status.style.cssText = 'margin:1rem 0 0;text-align:center;font-weight:700;color:#1c3159;';
      box.appendChild(status);
    }
    status.textContent = activeTier
      ? quantity + ' paires : remise de -' + activeTier.percentage + ' % ' + (applied ? 'appliqu\u00e9e au panier.' : 's\u00e9lectionn\u00e9e.')
      : (quantity > 0 ? 'Ajoutez encore une paire pour obtenir -10 %.' : 'Votre panier est vide.');
  }

  function replaceRenderedSection(sectionId, html) {
    if (!html) return;
    const current = document.getElementById('shopify-section-' + sectionId);
    if (!current) return;
    const drawer = current.querySelector('cart-drawer');
    const wasOpen = drawer && (drawer.classList.contains('active') || drawer.hasAttribute('open'));
    const parsed = new DOMParser().parseFromString(html, 'text/html');
    const replacement = parsed.getElementById('shopify-section-' + sectionId) || parsed.body.firstElementChild;
    if (!replacement) return;
    current.replaceWith(replacement);
    if (wasOpen) replacement.querySelector('cart-drawer')?.classList.add('active');
  }

  async function syncCartDiscount(refreshSections = true) {
    if (syncing) {
      syncQueued = true;
      return;
    }
    syncing = true;
    try {
      const root = window.Shopify?.routes?.root || '/';
      const cartResponse = await nativeFetch(root + 'cart.js', { credentials: 'same-origin', cache: 'no-store' });
      if (!cartResponse.ok) throw new Error('Lecture du panier impossible');
      const cart = await cartResponse.json();
      const quantity = Number(cart.item_count || 0);
      const tier = tierFor(quantity);
      const body = { discount: tier ? tier.code : '' };
      if (refreshSections) {
        body.sections = ['cart-drawer', 'cart-icon-bubble'];
        body.sections_url = window.location.pathname;
      }
      const updateResponse = await nativeFetch(root + 'cart/update.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body)
      });
      if (!updateResponse.ok) throw new Error('Application de la remise impossible');
      const updatedCart = await updateResponse.json();
      lastObservedQuantity = Number(updatedCart.item_count || quantity);
      updateOfferDisplay(Number(updatedCart.item_count || quantity), Boolean(tier));
      if (updatedCart.sections) {
        replaceRenderedSection('cart-drawer', updatedCart.sections['cart-drawer']);
        replaceRenderedSection('cart-icon-bubble', updatedCart.sections['cart-icon-bubble']);
      }
      document.dispatchEvent(new CustomEvent('chauxe:discount-updated', {
        detail: { quantity, percentage: tier ? tier.percentage : 0, code: tier ? tier.code : '' }
      }));
    } catch (error) {
      console.warn('CHAUXE : remise panier non appliquée', error);
    } finally {
      syncing = false;
      if (syncQueued) {
        syncQueued = false;
        scheduleSync(180, true);
      }
    }
  }

  function scheduleSync(delay = 500, refreshSections = true) {
    window.clearTimeout(syncTimer);
    syncTimer = window.setTimeout(() => syncCartDiscount(refreshSections), delay);
  }

  function syncAfterCartAction() {
    [450, 1100, 2200].forEach((delay) => {
      window.setTimeout(() => syncCartDiscount(true), delay);
    });
  }

  async function watchCartQuantity() {
    if (syncing) return;
    try {
      const root = window.Shopify?.routes?.root || '/';
      const response = await nativeFetch(root + 'cart.js', { credentials: 'same-origin', cache: 'no-store' });
      if (!response.ok) return;
      const cart = await response.json();
      const quantity = Number(cart.item_count || 0);
      if (lastObservedQuantity === null) {
        lastObservedQuantity = quantity;
        return;
      }
      if (quantity !== lastObservedQuantity) {
        lastObservedQuantity = quantity;
        await syncCartDiscount(true);
      }
    } catch (_) {}
  }

  function observeCartChanges() {
    const observer = new MutationObserver((mutations) => {
      ensureLeadFormCartButton();
      if (mutations.some((mutation) => mutation.type === 'attributes' && mutation.attributeName === 'data-selected')) {
        refreshUpsellOfferDisplay(0);
      }
      if (syncing || mutationCheckPending) return;
      mutationCheckPending = true;
      queueMicrotask(async () => {
        mutationCheckPending = false;
        await watchCartQuantity();
      });
    });
    observer.observe(document.body, {
      childList: true,
      subtree: true,
      characterData: true,
      attributes: true,
      attributeFilter: ['data-selected']
    });
  }

  window.fetch = async (...args) => {
    const response = await nativeFetch(...args);
    const request = args[0];
    const url = typeof request === 'string' ? request : (request && request.url) || '';
    if (cartMutation(url)) scheduleSync(350, true);
    if (cartAddition(url)) openCartAfterAdd();
    return response;
  };

  window.XMLHttpRequest = function ChauxeXMLHttpRequest() {
    const xhr = new NativeXHR();
    const nativeOpen = xhr.open;
    xhr.open = function (method, url, ...rest) {
      this.__chauxeCartMutation = cartMutation(url);
      this.__chauxeCartAddition = cartAddition(url);
      return nativeOpen.call(this, method, url, ...rest);
    };
    xhr.addEventListener('loadend', function () {
      if (this.status >= 200 && this.status < 400) {
        if (this.__chauxeCartMutation) scheduleSync(350, true);
        if (this.__chauxeCartAddition) openCartAfterAdd();
      }
    });
    return xhr;
  };
  window.XMLHttpRequest.prototype = NativeXHR.prototype;

  function isLeadFormOrderButton(button) {
    if (!button) return false;
    const text = (button.textContent || '').replace(/\s+/g, ' ').trim();
    return button.matches('.leadform-action-button, [data-button-id="order-now"]') ||
      text.includes('\u0623\u0637\u0644\u0628 \u0627\u0644\u0622\u0646');
  }

  function mainProductVariant() {
    const forms = Array.from(document.querySelectorAll('form[action*="/cart/add"]'));
    const form = forms.find((candidate) =>
      !candidate.closest('product-info-upsell, cart-drawer') &&
      candidate.querySelector('input[name="id"]')
    );
    if (!form) return null;
    const id = Number(form.querySelector('input[name="id"]')?.value || 0);
    const quantity = Math.max(1, Number(form.querySelector('input[name="quantity"]')?.value || 1));
    return id ? { id, quantity } : null;
  }

  function selectedUpsellVariants() {
    return Array.from(document.querySelectorAll('product-info-upsell[data-selected="true"]'))
      .map((upsell) => {
        const input = upsell.querySelector('form[action*="/cart/add"] input[name="id"]');
        const id = Number(input?.value || upsell.dataset.id || 0);
        return id ? { id, quantity: 1 } : null;
      })
      .filter(Boolean);
  }

  function clickLeadFormInDrawer() {
    openCartDrawer();
    const candidates = Array.from(document.querySelectorAll('cart-drawer button, cart-drawer a'));
    const button = candidates.find(isLeadFormOrderButton);
    if (!button) return false;
    requestedLeadOpened = true;
    button.click();
    window.setTimeout(() => { requestedLeadOpened = false; }, 1000);
    return true;
  }

  async function orderSelectedProductsWithLeadForm(event) {
    const button = event.target.closest('button, a');
    if (!isLeadFormOrderButton(button) || button.closest('cart-drawer') || requestedLeadOpened) return;

    const mainItem = mainProductVariant();
    const upsellItems = selectedUpsellVariants();
    if (!mainItem || upsellItems.length === 0) return;

    event.preventDefault();
    event.stopImmediatePropagation();
    if (button.disabled || button.dataset.chauxeLoading === 'true') return;
    button.dataset.chauxeLoading = 'true';
    button.setAttribute('aria-busy', 'true');

    try {
      const root = window.Shopify?.routes?.root || '/';
      const response = await nativeFetch(root + 'cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [mainItem, ...upsellItems] })
      });
      if (!response.ok) throw new Error('Ajout des produits s\u00e9lectionn\u00e9s impossible');

      await syncCartDiscount(true);
      openCartDrawer();
      let opened = false;
      [100, 350, 800, 1400].forEach((delay) => {
        window.setTimeout(() => {
          if (!opened) opened = clickLeadFormInDrawer();
        }, delay);
      });
    } catch (error) {
      console.warn('CHAUXE : commande LeadForm incompl\u00e8te', error);
      button.removeAttribute('aria-busy');
      delete button.dataset.chauxeLoading;
      window.alert('Impossible d\u2019ajouter tous les mod\u00e8les. Veuillez r\u00e9essayer.');
    }
  }
  document.addEventListener('click', orderSelectedProductsWithLeadForm, true);

  const cartControls = [
    'button[name="add"]', '.product-form__submit', '.upsell-toggle-btn',
    'cart-remove-button', '.cart-remove-button', 'a[href*="/cart/change"]',
    'quantity-input button', '.quantity__button', 'button[data-action*="quantity"]'
  ].join(',');

  document.addEventListener('click', (event) => {
    const control = event.target.closest(cartControls);
    if (!control) return;
    if (control.matches('.upsell-toggle-btn')) {
      [0, 80, 200].forEach((delay) => window.setTimeout(() => refreshUpsellOfferDisplay(0), delay));
      return;
    }
    if (control.matches('button[name="add"], .product-form__submit')) openCartAfterAdd();
    syncAfterCartAction();
  }, true);
  document.addEventListener('change', (event) => {
    if (event.target.matches('input[name="updates[]"], .quantity__input, select')) syncAfterCartAction();
    window.setTimeout(() => updateOfferDisplay(), 80);
  }, true);
  ['cart:updated', 'cart:refresh', 'shopify:cart:lines-update'].forEach((name) => {
    document.addEventListener(name, () => scheduleSync(300, true));
  });

  let redirecting = false;
  async function checkoutWithDiscount(event) {
    const control = event.target.closest('button[name="checkout"], input[name="checkout"], a[href="/checkout"], a[href$="/checkout"]');
    if (!control || redirecting) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    redirecting = true;
    await syncCartDiscount(false);
    window.location.assign((window.Shopify?.routes?.root || '/') + 'checkout');
  }
  document.addEventListener('click', checkoutWithDiscount, true);
  document.addEventListener('submit', (event) => {
    if (event.submitter && event.submitter.name === 'checkout') checkoutWithDiscount(event);
  }, true);

  const start = () => {
    updateOfferDisplay();
    ensureLeadFormCartButton();
    scheduleSync(250, false);
    window.setInterval(ensureLeadFormCartButton, 500);
    window.setInterval(watchCartQuantity, 1200);
    observeCartChanges();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
